/*!
 * This file was generated by jce-tools
 */
import { Taf } from '@huyafed/taf-network'
export var HUYA = HUYA || {}

HUYA.GetMomentBatchByVidRsp = function () {
  this.mCommentInfo = new Taf.Map(new Taf.INT64(), new HUYA.MomentInfo())
}

HUYA.GetMomentBatchByVidRsp.prototype.readFrom = function (is) {
  this.mCommentInfo = is.readMap(0, false, this.mCommentInfo)
}

HUYA.GetMomentBatchByVidRsp.prototype.writeTo = function (os) {
  os.writeMap(0, this.mCommentInfo)
}

HUYA.GetMomentBatchByVidRsp.prototype._clone = function () {
  return new HUYA.GetMomentBatchByVidRsp()
}
HUYA.GetMomentBatchByVidRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.GetMomentBatchByVidRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentInfo = function () {
  this.lMomId = 0
  this.iType = 0
  this.lUid = 0
  this.sNickName = ''
  this.sIconUrl = ''
  this.sTitle = ''
  this.sContent = ''
  this.iFavorCount = 0
  this.iCommentCount = 0
  this.iShareCount = 0
  this.vComment = new Taf.Vector(new HUYA.CommentInfo())
  this.iCTime = 0
  this.iStatus = 0
  this.iOpt = 0
  this.tVideoInfo = new HUYA.VideoInfo()
  this.vKeyWord = new Taf.Vector(new Taf.STRING())
  this.iHasDraw = 0
  this.vCoverUrl = new Taf.Vector(new Taf.STRING())
  this.sHtmlDoc = ''
  this.vTags = new Taf.Vector(new Taf.STRING())
  this.vBelongPlate = new Taf.Vector(new Taf.STRING())
  this.iBrowseCount = 0
  this.iCardType = 0
  this.vMomentAttachment = new Taf.Vector(new HUYA.MomentAttachment())
  this.iStepOnCount = 0
  this.iUserOpt = 0
  this.vMomentDecoration = new Taf.Vector(new HUYA.MomentDecorationItem())
  this.iTopStatus = 0
  this.sTraceId = ''
  this.mpServerContext = new Taf.Map(new Taf.STRING(), new Taf.STRING())
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING())
  this.sServerContext = ''
}

HUYA.MomentInfo.prototype.readFrom = function (is) {
  this.lMomId = is.readInt64(0, false, this.lMomId)
  this.iType = is.readInt32(1, false, this.iType)
  this.lUid = is.readInt64(2, false, this.lUid)
  this.sNickName = is.readString(3, false, this.sNickName)
  this.sIconUrl = is.readString(4, false, this.sIconUrl)
  this.sTitle = is.readString(5, false, this.sTitle)
  this.sContent = is.readString(6, false, this.sContent)
  this.iFavorCount = is.readInt32(7, false, this.iFavorCount)
  this.iCommentCount = is.readInt32(8, false, this.iCommentCount)
  this.iShareCount = is.readInt32(9, false, this.iShareCount)
  this.vComment = is.readVector(10, false, this.vComment)
  this.iCTime = is.readInt32(11, false, this.iCTime)
  this.iStatus = is.readInt32(12, false, this.iStatus)
  this.iOpt = is.readInt32(13, false, this.iOpt)
  this.tVideoInfo = is.readStruct(14, false, this.tVideoInfo)
  this.vKeyWord = is.readVector(15, false, this.vKeyWord)
  this.iHasDraw = is.readInt32(16, false, this.iHasDraw)
  this.vCoverUrl = is.readVector(17, false, this.vCoverUrl)
  this.sHtmlDoc = is.readString(18, false, this.sHtmlDoc)
  this.vTags = is.readVector(19, false, this.vTags)
  this.vBelongPlate = is.readVector(20, false, this.vBelongPlate)
  this.iBrowseCount = is.readInt32(21, false, this.iBrowseCount)
  this.iCardType = is.readInt32(22, false, this.iCardType)
  this.vMomentAttachment = is.readVector(23, false, this.vMomentAttachment)
  this.iStepOnCount = is.readInt32(24, false, this.iStepOnCount)
  this.iUserOpt = is.readInt32(25, false, this.iUserOpt)
  this.vMomentDecoration = is.readVector(26, false, this.vMomentDecoration)
  this.iTopStatus = is.readInt32(27, false, this.iTopStatus)
  this.sTraceId = is.readString(28, false, this.sTraceId)
  this.mpServerContext = is.readMap(29, false, this.mpServerContext)
  this.mpExtInfo = is.readMap(30, false, this.mpExtInfo)
  this.sServerContext = is.readString(31, false, this.sServerContext)
}

HUYA.MomentInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lMomId)
  os.writeInt32(1, this.iType)
  os.writeInt64(2, this.lUid)
  os.writeString(3, this.sNickName)
  os.writeString(4, this.sIconUrl)
  os.writeString(5, this.sTitle)
  os.writeString(6, this.sContent)
  os.writeInt32(7, this.iFavorCount)
  os.writeInt32(8, this.iCommentCount)
  os.writeInt32(9, this.iShareCount)
  os.writeVector(10, this.vComment)
  os.writeInt32(11, this.iCTime)
  os.writeInt32(12, this.iStatus)
  os.writeInt32(13, this.iOpt)
  os.writeStruct(14, this.tVideoInfo)
  os.writeVector(15, this.vKeyWord)
  os.writeInt32(16, this.iHasDraw)
  os.writeVector(17, this.vCoverUrl)
  os.writeString(18, this.sHtmlDoc)
  os.writeVector(19, this.vTags)
  os.writeVector(20, this.vBelongPlate)
  os.writeInt32(21, this.iBrowseCount)
  os.writeInt32(22, this.iCardType)
  os.writeVector(23, this.vMomentAttachment)
  os.writeInt32(24, this.iStepOnCount)
  os.writeInt32(25, this.iUserOpt)
  os.writeVector(26, this.vMomentDecoration)
  os.writeInt32(27, this.iTopStatus)
  os.writeString(28, this.sTraceId)
  os.writeMap(29, this.mpServerContext)
  os.writeMap(30, this.mpExtInfo)
  os.writeString(31, this.sServerContext)
}

HUYA.MomentInfo.prototype._clone = function () {
  return new HUYA.MomentInfo()
}
HUYA.MomentInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.CommentInfo = function () {
  this.lComId = 0
  this.lParentId = 0
  this.lMomId = 0
  this.lUid = 0
  this.sNickName = ''
  this.sIconUrl = ''
  this.sContent = ''
  this.iCTime = 0
  this.iFavorCount = 0
  this.iReplyCount = 0
  this.vComment = new Taf.Vector(HUYA.CommentInfo)
  this.lReplyToComId = 0
  this.lReplyToUid = 0
  this.sReplyToNickName = ''
  this.iStatus = 0
  this.iOpt = 0
  this.iFavoredByOnwer = 0
  this.iTopStatus = 0
  this.vCommentAttach = new Taf.Vector(new HUYA.CommentAttach())
  this.vTags = new Taf.Vector(new Taf.STRING())
  this.vCornerMark = new Taf.Vector(new HUYA.CommentCornerMark())
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING())
  this.vCommentDeco = new Taf.Vector(new HUYA.CommentDecoration())
  this.sCertSmallIcon = ''
  this.sReplyToCertSmallIcon = ''
}

HUYA.CommentInfo.prototype.readFrom = function (is) {
  this.lComId = is.readInt64(0, false, this.lComId)
  this.lParentId = is.readInt64(1, false, this.lParentId)
  this.lMomId = is.readInt64(2, false, this.lMomId)
  this.lUid = is.readInt64(3, false, this.lUid)
  this.sNickName = is.readString(4, false, this.sNickName)
  this.sIconUrl = is.readString(5, false, this.sIconUrl)
  this.sContent = is.readString(6, false, this.sContent)
  this.iCTime = is.readInt32(7, false, this.iCTime)
  this.iFavorCount = is.readInt32(8, false, this.iFavorCount)
  this.iReplyCount = is.readInt32(9, false, this.iReplyCount)
  this.vComment = is.readVector(10, false, this.vComment)
  this.lReplyToComId = is.readInt64(11, false, this.lReplyToComId)
  this.lReplyToUid = is.readInt64(12, false, this.lReplyToUid)
  this.sReplyToNickName = is.readString(13, false, this.sReplyToNickName)
  this.iStatus = is.readInt32(14, false, this.iStatus)
  this.iOpt = is.readInt32(15, false, this.iOpt)
  this.iFavoredByOnwer = is.readInt32(16, false, this.iFavoredByOnwer)
  this.iTopStatus = is.readInt32(20, false, this.iTopStatus)
  this.vCommentAttach = is.readVector(21, false, this.vCommentAttach)
  this.vTags = is.readVector(22, false, this.vTags)
  this.vCornerMark = is.readVector(23, false, this.vCornerMark)
  this.mpExtInfo = is.readMap(24, false, this.mpExtInfo)
  this.vCommentDeco = is.readVector(25, false, this.vCommentDeco)
  this.sCertSmallIcon = is.readString(26, false, this.sCertSmallIcon)
  this.sReplyToCertSmallIcon = is.readString(27, false, this.sReplyToCertSmallIcon)
}

HUYA.CommentInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lComId)
  os.writeInt64(1, this.lParentId)
  os.writeInt64(2, this.lMomId)
  os.writeInt64(3, this.lUid)
  os.writeString(4, this.sNickName)
  os.writeString(5, this.sIconUrl)
  os.writeString(6, this.sContent)
  os.writeInt32(7, this.iCTime)
  os.writeInt32(8, this.iFavorCount)
  os.writeInt32(9, this.iReplyCount)
  os.writeVector(10, this.vComment)
  os.writeInt64(11, this.lReplyToComId)
  os.writeInt64(12, this.lReplyToUid)
  os.writeString(13, this.sReplyToNickName)
  os.writeInt32(14, this.iStatus)
  os.writeInt32(15, this.iOpt)
  os.writeInt32(16, this.iFavoredByOnwer)
  os.writeInt32(20, this.iTopStatus)
  os.writeVector(21, this.vCommentAttach)
  os.writeVector(22, this.vTags)
  os.writeVector(23, this.vCornerMark)
  os.writeMap(24, this.mpExtInfo)
  os.writeVector(25, this.vCommentDeco)
  os.writeString(26, this.sCertSmallIcon)
  os.writeString(27, this.sReplyToCertSmallIcon)
}

HUYA.CommentInfo.prototype._clone = function () {
  return new HUYA.CommentInfo()
}
HUYA.CommentInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.CommentInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.CommentAttach = function () {
  this.iType = 0
  this.sContent = ''
  this.sFileMD5 = ''
  this.vAtContent = new Taf.Vector(new HUYA.MomentAtContent())
  this.iDuration = 0
}

HUYA.CommentAttach.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType)
  this.sContent = is.readString(1, false, this.sContent)
  this.sFileMD5 = is.readString(2, false, this.sFileMD5)
  this.vAtContent = is.readVector(3, false, this.vAtContent)
  this.iDuration = is.readInt32(4, false, this.iDuration)
}

HUYA.CommentAttach.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType)
  os.writeString(1, this.sContent)
  os.writeString(2, this.sFileMD5)
  os.writeVector(3, this.vAtContent)
  os.writeInt32(4, this.iDuration)
}

HUYA.CommentAttach.prototype._clone = function () {
  return new HUYA.CommentAttach()
}
HUYA.CommentAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.CommentAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentAtContent = function () {
  this.lAtUid = 0
  this.sAtNick = ''
  this.iBegin = 0
  this.iEnd = 0
}

HUYA.MomentAtContent.prototype.readFrom = function (is) {
  this.lAtUid = is.readInt64(0, false, this.lAtUid)
  this.sAtNick = is.readString(1, false, this.sAtNick)
  this.iBegin = is.readInt32(2, false, this.iBegin)
  this.iEnd = is.readInt32(3, false, this.iEnd)
}

HUYA.MomentAtContent.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lAtUid)
  os.writeString(1, this.sAtNick)
  os.writeInt32(2, this.iBegin)
  os.writeInt32(3, this.iEnd)
}

HUYA.MomentAtContent.prototype._clone = function () {
  return new HUYA.MomentAtContent()
}
HUYA.MomentAtContent.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentAtContent.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.CommentCornerMark = function () {
  this.iId = 0
  this.sContent = ''
}

HUYA.CommentCornerMark.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId)
  this.sContent = is.readString(1, false, this.sContent)
}

HUYA.CommentCornerMark.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iId)
  os.writeString(1, this.sContent)
}

HUYA.CommentCornerMark.prototype._clone = function () {
  return new HUYA.CommentCornerMark()
}
HUYA.CommentCornerMark.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.CommentCornerMark.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.CommentDecoration = function () {
  this.iType = 0
  this.vData = new Taf.BinBuffer()
}

HUYA.CommentDecoration.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType)
  this.vData = is.readBytes(1, false, this.vData)
}

HUYA.CommentDecoration.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType)
  os.writeBytes(1, this.vData)
}

HUYA.CommentDecoration.prototype._clone = function () {
  return new HUYA.CommentDecoration()
}
HUYA.CommentDecoration.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.CommentDecoration.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.VideoInfo = function () {
  this.lUid = 0
  this.sAvatarUrl = ''
  this.sNickName = ''
  this.lVid = 0
  this.sVideoTitle = ''
  this.sVideoCover = ''
  this.lVideoPlayNum = 0
  this.lVideoCommentNum = 0
  this.sVideoDuration = ''
  this.sVideoUrl = ''
  this.sVideoUploadTime = ''
  this.sVideoChannel = ''
  this.sCategory = ''
  this.vDefinitions = new Taf.Vector(new HUYA.VideoDefinition())
  this.iVideoRecommend = 0
  this.bVideoDot = true
  this.lVideoRank = 0
  this.bVideoHasRanked = true
  this.sTraceId = ''
  this.lActorUid = 0
  this.sActorNick = ''
  this.sActorAvatarUrl = ''
  this.iExtPlayTimes = 0
  this.sVideoBigCover = ''
  this.iCommentCount = 0
  this.vTags = new Taf.Vector(new Taf.STRING())
  this.iVideoDirection = 0
  this.sBriefIntroduction = ''
  this.iVideoType = 0
  this.iFavorCount = 0
  this.lMomId = 0
  this.sSubTitle = ''
  this.mMiscData = new Taf.Map(new Taf.STRING(), new Taf.STRING())
  this.vRawDefinitions = new Taf.Vector(new HUYA.VideoDefinition())
  this.canPlay = 0
  this.status = 0
  this.vPortraitCovers = new Taf.Vector(new HUYA.PortraitCover())
}

HUYA.VideoInfo.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid)
  this.sAvatarUrl = is.readString(1, false, this.sAvatarUrl)
  this.sNickName = is.readString(2, false, this.sNickName)
  this.lVid = is.readInt64(3, false, this.lVid)
  this.sVideoTitle = is.readString(4, false, this.sVideoTitle)
  this.sVideoCover = is.readString(5, false, this.sVideoCover)
  this.lVideoPlayNum = is.readInt64(6, false, this.lVideoPlayNum)
  this.lVideoCommentNum = is.readInt64(7, false, this.lVideoCommentNum)
  this.sVideoDuration = is.readString(8, false, this.sVideoDuration)
  this.sVideoUrl = is.readString(9, false, this.sVideoUrl)
  this.sVideoUploadTime = is.readString(10, false, this.sVideoUploadTime)
  this.sVideoChannel = is.readString(11, false, this.sVideoChannel)
  this.sCategory = is.readString(12, false, this.sCategory)
  this.vDefinitions = is.readVector(13, false, this.vDefinitions)
  this.iVideoRecommend = is.readInt32(14, false, this.iVideoRecommend)
  this.bVideoDot = is.readBoolean(15, false, this.bVideoDot)
  this.lVideoRank = is.readInt64(16, false, this.lVideoRank)
  this.bVideoHasRanked = is.readBoolean(17, false, this.bVideoHasRanked)
  this.sTraceId = is.readString(18, false, this.sTraceId)
  this.lActorUid = is.readInt64(19, false, this.lActorUid)
  this.sActorNick = is.readString(20, false, this.sActorNick)
  this.sActorAvatarUrl = is.readString(21, false, this.sActorAvatarUrl)
  this.iExtPlayTimes = is.readInt32(22, false, this.iExtPlayTimes)
  this.sVideoBigCover = is.readString(23, false, this.sVideoBigCover)
  this.iCommentCount = is.readInt32(24, false, this.iCommentCount)
  this.vTags = is.readVector(25, false, this.vTags)
  this.iVideoDirection = is.readInt32(26, false, this.iVideoDirection)
  this.sBriefIntroduction = is.readString(27, false, this.sBriefIntroduction)
  this.iVideoType = is.readInt32(28, false, this.iVideoType)
  this.iFavorCount = is.readInt32(29, false, this.iFavorCount)
  this.lMomId = is.readInt64(30, false, this.lMomId)
  this.sSubTitle = is.readString(31, false, this.sSubTitle)
  this.mMiscData = is.readMap(32, false, this.mMiscData)
  this.vRawDefinitions = is.readVector(33, false, this.vRawDefinitions)
  this.canPlay = is.readInt32(34, false, this.canPlay)
  this.status = is.readInt32(35, false, this.status)
  this.vPortraitCovers = is.readVector(36, false, this.vPortraitCovers)
}

HUYA.VideoInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid)
  os.writeString(1, this.sAvatarUrl)
  os.writeString(2, this.sNickName)
  os.writeInt64(3, this.lVid)
  os.writeString(4, this.sVideoTitle)
  os.writeString(5, this.sVideoCover)
  os.writeInt64(6, this.lVideoPlayNum)
  os.writeInt64(7, this.lVideoCommentNum)
  os.writeString(8, this.sVideoDuration)
  os.writeString(9, this.sVideoUrl)
  os.writeString(10, this.sVideoUploadTime)
  os.writeString(11, this.sVideoChannel)
  os.writeString(12, this.sCategory)
  os.writeVector(13, this.vDefinitions)
  os.writeInt32(14, this.iVideoRecommend)
  os.writeBoolean(15, this.bVideoDot)
  os.writeInt64(16, this.lVideoRank)
  os.writeBoolean(17, this.bVideoHasRanked)
  os.writeString(18, this.sTraceId)
  os.writeInt64(19, this.lActorUid)
  os.writeString(20, this.sActorNick)
  os.writeString(21, this.sActorAvatarUrl)
  os.writeInt32(22, this.iExtPlayTimes)
  os.writeString(23, this.sVideoBigCover)
  os.writeInt32(24, this.iCommentCount)
  os.writeVector(25, this.vTags)
  os.writeInt32(26, this.iVideoDirection)
  os.writeString(27, this.sBriefIntroduction)
  os.writeInt32(28, this.iVideoType)
  os.writeInt32(29, this.iFavorCount)
  os.writeInt64(30, this.lMomId)
  os.writeString(31, this.sSubTitle)
  os.writeMap(32, this.mMiscData)
  os.writeVector(33, this.vRawDefinitions)
  os.writeInt32(34, this.canPlay)
  os.writeInt32(35, this.status)
  os.writeVector(36, this.vPortraitCovers)
}

HUYA.VideoInfo.prototype._clone = function () {
  return new HUYA.VideoInfo()
}
HUYA.VideoInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.VideoInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.VideoDefinition = function () {
  this.sSize = ''
  this.sWidth = ''
  this.sHeight = ''
  this.sDefinition = ''
  this.sUrl = ''
  this.sM3u8 = ''
  this.sDefName = ''
  this.sTs1Url = ''
  this.sTs1Offset = ''
  this.iLineIndex = 0
  this.iBitRate = 0
  this.mpExtraParam = new Taf.Map(new Taf.STRING(), new Taf.STRING())
  this.vStreamInfo = new Taf.Vector(new HUYA.VideoStreamInfo())
  this.sCodec = ''
  this.sFormat = ''
  this.sDuration = ''
  this.iM3u8LineIndex = 0
}

HUYA.VideoDefinition.prototype.readFrom = function (is) {
  this.sSize = is.readString(0, false, this.sSize)
  this.sWidth = is.readString(1, false, this.sWidth)
  this.sHeight = is.readString(2, false, this.sHeight)
  this.sDefinition = is.readString(3, false, this.sDefinition)
  this.sUrl = is.readString(4, false, this.sUrl)
  this.sM3u8 = is.readString(5, false, this.sM3u8)
  this.sDefName = is.readString(6, false, this.sDefName)
  this.sTs1Url = is.readString(7, false, this.sTs1Url)
  this.sTs1Offset = is.readString(8, false, this.sTs1Offset)
  this.iLineIndex = is.readInt32(9, false, this.iLineIndex)
  this.iBitRate = is.readInt32(10, false, this.iBitRate)
  this.mpExtraParam = is.readMap(11, false, this.mpExtraParam)
  this.vStreamInfo = is.readVector(12, false, this.vStreamInfo)
  this.sCodec = is.readString(13, false, this.sCodec)
  this.sFormat = is.readString(14, false, this.sFormat)
  this.sDuration = is.readString(15, false, this.sDuration)
  this.iM3u8LineIndex = is.readInt32(16, false, this.iM3u8LineIndex)
}

HUYA.VideoDefinition.prototype.writeTo = function (os) {
  os.writeString(0, this.sSize)
  os.writeString(1, this.sWidth)
  os.writeString(2, this.sHeight)
  os.writeString(3, this.sDefinition)
  os.writeString(4, this.sUrl)
  os.writeString(5, this.sM3u8)
  os.writeString(6, this.sDefName)
  os.writeString(7, this.sTs1Url)
  os.writeString(8, this.sTs1Offset)
  os.writeInt32(9, this.iLineIndex)
  os.writeInt32(10, this.iBitRate)
  os.writeMap(11, this.mpExtraParam)
  os.writeVector(12, this.vStreamInfo)
  os.writeString(13, this.sCodec)
  os.writeString(14, this.sFormat)
  os.writeString(15, this.sDuration)
  os.writeInt32(16, this.iM3u8LineIndex)
}

HUYA.VideoDefinition.prototype._clone = function () {
  return new HUYA.VideoDefinition()
}
HUYA.VideoDefinition.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.VideoDefinition.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.VideoStreamInfo = function () {
  this.sSize = ''
  this.sWidth = ''
  this.sHeight = ''
  this.sFormat = ''
  this.sUrl = ''
  this.sM3u8 = ''
  this.sTs1Url = ''
  this.sTs1Offset = ''
  this.iBitRate = 0
  this.sCodec = ''
  this.mpExtraParam = new Taf.Map(new Taf.STRING(), new Taf.STRING())
  this.iLineIndex = 0
  this.iM3u8LineIndex = 0
}

HUYA.VideoStreamInfo.prototype.readFrom = function (is) {
  this.sSize = is.readString(0, false, this.sSize)
  this.sWidth = is.readString(1, false, this.sWidth)
  this.sHeight = is.readString(2, false, this.sHeight)
  this.sFormat = is.readString(3, false, this.sFormat)
  this.sUrl = is.readString(4, false, this.sUrl)
  this.sM3u8 = is.readString(5, false, this.sM3u8)
  this.sTs1Url = is.readString(6, false, this.sTs1Url)
  this.sTs1Offset = is.readString(7, false, this.sTs1Offset)
  this.iBitRate = is.readInt32(8, false, this.iBitRate)
  this.sCodec = is.readString(9, false, this.sCodec)
  this.mpExtraParam = is.readMap(10, false, this.mpExtraParam)
  this.iLineIndex = is.readInt32(11, false, this.iLineIndex)
  this.iM3u8LineIndex = is.readInt32(12, false, this.iM3u8LineIndex)
}

HUYA.VideoStreamInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sSize)
  os.writeString(1, this.sWidth)
  os.writeString(2, this.sHeight)
  os.writeString(3, this.sFormat)
  os.writeString(4, this.sUrl)
  os.writeString(5, this.sM3u8)
  os.writeString(6, this.sTs1Url)
  os.writeString(7, this.sTs1Offset)
  os.writeInt32(8, this.iBitRate)
  os.writeString(9, this.sCodec)
  os.writeMap(10, this.mpExtraParam)
  os.writeInt32(11, this.iLineIndex)
  os.writeInt32(12, this.iM3u8LineIndex)
}

HUYA.VideoStreamInfo.prototype._clone = function () {
  return new HUYA.VideoStreamInfo()
}
HUYA.VideoStreamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.VideoStreamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.PortraitCover = function () {
  this.seq = 0
  this.width = 0
  this.height = 0
  this.url = ''
  this.similarGroup = ''
  this.forceDoubleCardHeight = 0
}

HUYA.PortraitCover.prototype.readFrom = function (is) {
  this.seq = is.readInt32(0, false, this.seq)
  this.width = is.readInt32(1, false, this.width)
  this.height = is.readInt32(2, false, this.height)
  this.url = is.readString(3, false, this.url)
  this.similarGroup = is.readString(4, false, this.similarGroup)
  this.forceDoubleCardHeight = is.readInt32(5, false, this.forceDoubleCardHeight)
}

HUYA.PortraitCover.prototype.writeTo = function (os) {
  os.writeInt32(0, this.seq)
  os.writeInt32(1, this.width)
  os.writeInt32(2, this.height)
  os.writeString(3, this.url)
  os.writeString(4, this.similarGroup)
  os.writeInt32(5, this.forceDoubleCardHeight)
}

HUYA.PortraitCover.prototype._clone = function () {
  return new HUYA.PortraitCover()
}
HUYA.PortraitCover.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.PortraitCover.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentAttachment = function () {
  this.iType = 0
  this.sContent = ''
  this.sUrl = new Taf.Vector(new HUYA.MomentUrl())
  this.iDataType = 0
  this.sData = new Taf.BinBuffer()
  this.vAtContent = new Taf.Vector(new HUYA.MomentAtContent())
  this.vAttachLink = new Taf.Vector(new Taf.STRING())
  this.sVoteId = ''
  this.lVideoId = 0
  this.vAction = new Taf.Vector(new HUYA.MomentUrl())
  this.tInfo = new HUYA.MomentGoodsInfo()
  this.tForwardedMoment = new HUYA.ForwardedMomAttach()
  this.tVote = new HUYA.MomentVoteInfo()
  this.tVideoCollection = new HUYA.MomentVideoCollectionAttach()
  this.vGuessInfo = new Taf.Vector(new HUYA.MomentGuessInfoAttach())
  this.vCommonScoreInfo = new Taf.Vector(new HUYA.MomentCommonScoreInfo())
  this.vCommonScoreObject = new Taf.Vector(new HUYA.MomentAttachCommonScoreObject())
}

HUYA.MomentAttachment.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType)
  this.sContent = is.readString(1, false, this.sContent)
  this.sUrl = is.readVector(2, false, this.sUrl)
  this.iDataType = is.readInt32(3, false, this.iDataType)
  this.sData = is.readBytes(4, false, this.sData)
  this.vAtContent = is.readVector(5, false, this.vAtContent)
  this.vAttachLink = is.readVector(6, false, this.vAttachLink)
  this.sVoteId = is.readString(7, false, this.sVoteId)
  this.lVideoId = is.readInt64(8, false, this.lVideoId)
  this.vAction = is.readVector(9, false, this.vAction)
  this.tInfo = is.readStruct(10, false, this.tInfo)
  this.tForwardedMoment = is.readStruct(12, false, this.tForwardedMoment)
  this.tVote = is.readStruct(13, false, this.tVote)
  this.tVideoCollection = is.readStruct(14, false, this.tVideoCollection)
  this.vGuessInfo = is.readVector(15, false, this.vGuessInfo)
  this.vCommonScoreInfo = is.readVector(16, false, this.vCommonScoreInfo)
  this.vCommonScoreObject = is.readVector(17, false, this.vCommonScoreObject)
}

HUYA.MomentAttachment.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType)
  os.writeString(1, this.sContent)
  os.writeVector(2, this.sUrl)
  os.writeInt32(3, this.iDataType)
  os.writeBytes(4, this.sData)
  os.writeVector(5, this.vAtContent)
  os.writeVector(6, this.vAttachLink)
  os.writeString(7, this.sVoteId)
  os.writeInt64(8, this.lVideoId)
  os.writeVector(9, this.vAction)
  os.writeStruct(10, this.tInfo)
  os.writeStruct(12, this.tForwardedMoment)
  os.writeStruct(13, this.tVote)
  os.writeStruct(14, this.tVideoCollection)
  os.writeVector(15, this.vGuessInfo)
  os.writeVector(16, this.vCommonScoreInfo)
  os.writeVector(17, this.vCommonScoreObject)
}

HUYA.MomentAttachment.prototype._clone = function () {
  return new HUYA.MomentAttachment()
}
HUYA.MomentAttachment.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentAttachment.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentUrl = function () {
  this.sCover = ''
  this.sUrl = ''
  this.iDirection = 0
  this.iDuration = 0
  this.sFileMD5 = ''
  this.sText = ''
  this.iIsIllegal = 0
  this.iCoverWidth = 0
  this.iCoverHeight = 0
  this.tOriPicMeta = new HUYA.MomentOriginalPicMetaData()
  this.iPicType = 0
}

HUYA.MomentUrl.prototype.readFrom = function (is) {
  this.sCover = is.readString(0, false, this.sCover)
  this.sUrl = is.readString(1, false, this.sUrl)
  this.iDirection = is.readInt32(2, false, this.iDirection)
  this.iDuration = is.readInt32(3, false, this.iDuration)
  this.sFileMD5 = is.readString(4, false, this.sFileMD5)
  this.sText = is.readString(5, false, this.sText)
  this.iIsIllegal = is.readInt32(6, false, this.iIsIllegal)
  this.iCoverWidth = is.readInt32(7, false, this.iCoverWidth)
  this.iCoverHeight = is.readInt32(9, false, this.iCoverHeight)
  this.tOriPicMeta = is.readStruct(10, false, this.tOriPicMeta)
  this.iPicType = is.readInt32(11, false, this.iPicType)
}

HUYA.MomentUrl.prototype.writeTo = function (os) {
  os.writeString(0, this.sCover)
  os.writeString(1, this.sUrl)
  os.writeInt32(2, this.iDirection)
  os.writeInt32(3, this.iDuration)
  os.writeString(4, this.sFileMD5)
  os.writeString(5, this.sText)
  os.writeInt32(6, this.iIsIllegal)
  os.writeInt32(7, this.iCoverWidth)
  os.writeInt32(9, this.iCoverHeight)
  os.writeStruct(10, this.tOriPicMeta)
  os.writeInt32(11, this.iPicType)
}

HUYA.MomentUrl.prototype._clone = function () {
  return new HUYA.MomentUrl()
}
HUYA.MomentUrl.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentUrl.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentOriginalPicMetaData = function () {
  this.iWidth = 0
  this.iHeight = 0
}

HUYA.MomentOriginalPicMetaData.prototype.readFrom = function (is) {
  this.iWidth = is.readInt32(0, false, this.iWidth)
  this.iHeight = is.readInt32(1, false, this.iHeight)
}

HUYA.MomentOriginalPicMetaData.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iWidth)
  os.writeInt32(1, this.iHeight)
}

HUYA.MomentOriginalPicMetaData.prototype._clone = function () {
  return new HUYA.MomentOriginalPicMetaData()
}
HUYA.MomentOriginalPicMetaData.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentOriginalPicMetaData.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentGoodsInfo = function () {
  this.vDetail = new Taf.Vector(new HUYA.GoodsDetail())
}

HUYA.MomentGoodsInfo.prototype.readFrom = function (is) {
  this.vDetail = is.readVector(0, false, this.vDetail)
}

HUYA.MomentGoodsInfo.prototype.writeTo = function (os) {
  os.writeVector(0, this.vDetail)
}

HUYA.MomentGoodsInfo.prototype._clone = function () {
  return new HUYA.MomentGoodsInfo()
}
HUYA.MomentGoodsInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentGoodsInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.GoodsDetail = function () {
  this.spuId = ''
  this.platform = ''
  this.name = ''
  this.imageUrl = ''
  this.minPrice = 0
  this.maxPrice = 0
  this.marketPrice = 0
  this.sAction = ''
}

HUYA.GoodsDetail.prototype.readFrom = function (is) {
  this.spuId = is.readString(0, false, this.spuId)
  this.platform = is.readString(1, false, this.platform)
  this.name = is.readString(2, false, this.name)
  this.imageUrl = is.readString(3, false, this.imageUrl)
  this.minPrice = is.readInt64(4, false, this.minPrice)
  this.maxPrice = is.readInt64(5, false, this.maxPrice)
  this.marketPrice = is.readInt64(6, false, this.marketPrice)
  this.sAction = is.readString(7, false, this.sAction)
}

HUYA.GoodsDetail.prototype.writeTo = function (os) {
  os.writeString(0, this.spuId)
  os.writeString(1, this.platform)
  os.writeString(2, this.name)
  os.writeString(3, this.imageUrl)
  os.writeInt64(4, this.minPrice)
  os.writeInt64(5, this.maxPrice)
  os.writeInt64(6, this.marketPrice)
  os.writeString(7, this.sAction)
}

HUYA.GoodsDetail.prototype._clone = function () {
  return new HUYA.GoodsDetail()
}
HUYA.GoodsDetail.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.GoodsDetail.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.ForwardedMomAttach = function () {
  this.lForwardedMomId = 0
  this.vForwardMoment = new Taf.Vector(new HUYA.ForwardedMomentAbstract())
  this.vOriginMomentData = new Taf.BinBuffer()
}

HUYA.ForwardedMomAttach.prototype.readFrom = function (is) {
  this.lForwardedMomId = is.readInt64(0, false, this.lForwardedMomId)
  this.vForwardMoment = is.readVector(1, false, this.vForwardMoment)
  this.vOriginMomentData = is.readBytes(2, false, this.vOriginMomentData)
}

HUYA.ForwardedMomAttach.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lForwardedMomId)
  os.writeVector(1, this.vForwardMoment)
  os.writeBytes(2, this.vOriginMomentData)
}

HUYA.ForwardedMomAttach.prototype._clone = function () {
  return new HUYA.ForwardedMomAttach()
}
HUYA.ForwardedMomAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.ForwardedMomAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.ForwardedMomentAbstract = function () {
  this.lMomId = 0
  this.lAuthorUid = 0
  this.sAuthorNick = ''
  this.sTitle = ''
  this.iHasPicture = 0
}

HUYA.ForwardedMomentAbstract.prototype.readFrom = function (is) {
  this.lMomId = is.readInt64(0, false, this.lMomId)
  this.lAuthorUid = is.readInt64(1, false, this.lAuthorUid)
  this.sAuthorNick = is.readString(2, false, this.sAuthorNick)
  this.sTitle = is.readString(3, false, this.sTitle)
  this.iHasPicture = is.readInt32(4, false, this.iHasPicture)
}

HUYA.ForwardedMomentAbstract.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lMomId)
  os.writeInt64(1, this.lAuthorUid)
  os.writeString(2, this.sAuthorNick)
  os.writeString(3, this.sTitle)
  os.writeInt32(4, this.iHasPicture)
}

HUYA.ForwardedMomentAbstract.prototype._clone = function () {
  return new HUYA.ForwardedMomentAbstract()
}
HUYA.ForwardedMomentAbstract.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.ForwardedMomentAbstract.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentVoteInfo = function () {
  this.sVoteId = ''
  this.sVoteTitle = ''
  this.vVoteOption = new Taf.Vector(new HUYA.MomentVoteOption())
  this.mItemCount = new Taf.Map(new Taf.STRING(), new Taf.INT64())
  this.vUserChoose = new Taf.Vector(new Taf.STRING())
  this.iVoteShowStyle = 0
  this.lBeginTime = 0
  this.lEndTime = 0
}

HUYA.MomentVoteInfo.prototype.readFrom = function (is) {
  this.sVoteId = is.readString(0, false, this.sVoteId)
  this.sVoteTitle = is.readString(1, false, this.sVoteTitle)
  this.vVoteOption = is.readVector(2, false, this.vVoteOption)
  this.mItemCount = is.readMap(3, false, this.mItemCount)
  this.vUserChoose = is.readVector(4, false, this.vUserChoose)
  this.iVoteShowStyle = is.readInt32(5, false, this.iVoteShowStyle)
  this.lBeginTime = is.readInt64(6, false, this.lBeginTime)
  this.lEndTime = is.readInt64(7, false, this.lEndTime)
}

HUYA.MomentVoteInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sVoteId)
  os.writeString(1, this.sVoteTitle)
  os.writeVector(2, this.vVoteOption)
  os.writeMap(3, this.mItemCount)
  os.writeVector(4, this.vUserChoose)
  os.writeInt32(5, this.iVoteShowStyle)
  os.writeInt64(6, this.lBeginTime)
  os.writeInt64(7, this.lEndTime)
}

HUYA.MomentVoteInfo.prototype._clone = function () {
  return new HUYA.MomentVoteInfo()
}
HUYA.MomentVoteInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentVoteInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentVoteOption = function () {
  this.sOptionId = ''
  this.sTitle = ''
  this.sPicUrl = ''
}

HUYA.MomentVoteOption.prototype.readFrom = function (is) {
  this.sOptionId = is.readString(0, false, this.sOptionId)
  this.sTitle = is.readString(1, false, this.sTitle)
  this.sPicUrl = is.readString(2, false, this.sPicUrl)
}

HUYA.MomentVoteOption.prototype.writeTo = function (os) {
  os.writeString(0, this.sOptionId)
  os.writeString(1, this.sTitle)
  os.writeString(2, this.sPicUrl)
}

HUYA.MomentVoteOption.prototype._clone = function () {
  return new HUYA.MomentVoteOption()
}
HUYA.MomentVoteOption.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentVoteOption.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentVideoCollectionAttach = function () {
  this.iCollectionId = 0
  this.iNo = 0
  this.lFirstVid = 0
}

HUYA.MomentVideoCollectionAttach.prototype.readFrom = function (is) {
  this.iCollectionId = is.readInt32(0, false, this.iCollectionId)
  this.iNo = is.readInt32(1, false, this.iNo)
  this.lFirstVid = is.readInt64(2, false, this.lFirstVid)
}

HUYA.MomentVideoCollectionAttach.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iCollectionId)
  os.writeInt32(1, this.iNo)
  os.writeInt64(2, this.lFirstVid)
}

HUYA.MomentVideoCollectionAttach.prototype._clone = function () {
  return new HUYA.MomentVideoCollectionAttach()
}
HUYA.MomentVideoCollectionAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentVideoCollectionAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentGuessInfoAttach = function () {
  this.vGuessInfo = new Taf.BinBuffer()
  this.tMatchGuessCardInfo = new HUYA.MatchGuessCardInfo()
}

HUYA.MomentGuessInfoAttach.prototype.readFrom = function (is) {
  this.vGuessInfo = is.readBytes(1, false, this.vGuessInfo)
  this.tMatchGuessCardInfo = is.readStruct(2, false, this.tMatchGuessCardInfo)
}

HUYA.MomentGuessInfoAttach.prototype.writeTo = function (os) {
  os.writeBytes(1, this.vGuessInfo)
  os.writeStruct(2, this.tMatchGuessCardInfo)
}

HUYA.MomentGuessInfoAttach.prototype._clone = function () {
  return new HUYA.MomentGuessInfoAttach()
}
HUYA.MomentGuessInfoAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentGuessInfoAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MatchGuessCardInfo = function () {
  this.iScheduleId = 0
  this.sScheduleName = ''
  this.lBeginTime = 0
  this.lEndTime = 0
  this.vTeam = new Taf.Vector(new HUYA.MatchGuessCardTeamInfo())
  this.sJumpUrl = ''
  this.iMatchId = 0
  this.sScheduleDesc = ''
}

HUYA.MatchGuessCardInfo.prototype.readFrom = function (is) {
  this.iScheduleId = is.readInt32(0, false, this.iScheduleId)
  this.sScheduleName = is.readString(1, false, this.sScheduleName)
  this.lBeginTime = is.readInt64(2, false, this.lBeginTime)
  this.lEndTime = is.readInt64(3, false, this.lEndTime)
  this.vTeam = is.readVector(4, false, this.vTeam)
  this.sJumpUrl = is.readString(5, false, this.sJumpUrl)
  this.iMatchId = is.readInt32(6, false, this.iMatchId)
  this.sScheduleDesc = is.readString(7, false, this.sScheduleDesc)
}

HUYA.MatchGuessCardInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iScheduleId)
  os.writeString(1, this.sScheduleName)
  os.writeInt64(2, this.lBeginTime)
  os.writeInt64(3, this.lEndTime)
  os.writeVector(4, this.vTeam)
  os.writeString(5, this.sJumpUrl)
  os.writeInt32(6, this.iMatchId)
  os.writeString(7, this.sScheduleDesc)
}

HUYA.MatchGuessCardInfo.prototype._clone = function () {
  return new HUYA.MatchGuessCardInfo()
}
HUYA.MatchGuessCardInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MatchGuessCardInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MatchGuessCardTeamInfo = function () {
  this.iTeamId = 0
  this.sTeamName = ''
  this.sTeamLogo = ''
  this.iScore = 0
}

HUYA.MatchGuessCardTeamInfo.prototype.readFrom = function (is) {
  this.iTeamId = is.readInt32(0, false, this.iTeamId)
  this.sTeamName = is.readString(1, false, this.sTeamName)
  this.sTeamLogo = is.readString(2, false, this.sTeamLogo)
  this.iScore = is.readInt32(3, false, this.iScore)
}

HUYA.MatchGuessCardTeamInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iTeamId)
  os.writeString(1, this.sTeamName)
  os.writeString(2, this.sTeamLogo)
  os.writeInt32(3, this.iScore)
}

HUYA.MatchGuessCardTeamInfo.prototype._clone = function () {
  return new HUYA.MatchGuessCardTeamInfo()
}
HUYA.MatchGuessCardTeamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MatchGuessCardTeamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentCommonScoreInfo = function () {
  this.lObjListId = 0
}

HUYA.MomentCommonScoreInfo.prototype.readFrom = function (is) {
  this.lObjListId = is.readInt64(0, false, this.lObjListId)
}

HUYA.MomentCommonScoreInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lObjListId)
}

HUYA.MomentCommonScoreInfo.prototype._clone = function () {
  return new HUYA.MomentCommonScoreInfo()
}
HUYA.MomentCommonScoreInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentCommonScoreInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentAttachCommonScoreObject = function () {
  this.lObjId = 0
}

HUYA.MomentAttachCommonScoreObject.prototype.readFrom = function (is) {
  this.lObjId = is.readInt64(0, false, this.lObjId)
}

HUYA.MomentAttachCommonScoreObject.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lObjId)
}

HUYA.MomentAttachCommonScoreObject.prototype._clone = function () {
  return new HUYA.MomentAttachCommonScoreObject()
}
HUYA.MomentAttachCommonScoreObject.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentAttachCommonScoreObject.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.MomentDecorationItem = function () {
  this.iType = 0
  this.vData = new Taf.BinBuffer()
}

HUYA.MomentDecorationItem.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType)
  this.vData = is.readBytes(1, false, this.vData)
}

HUYA.MomentDecorationItem.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType)
  os.writeBytes(1, this.vData)
}

HUYA.MomentDecorationItem.prototype._clone = function () {
  return new HUYA.MomentDecorationItem()
}
HUYA.MomentDecorationItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.MomentDecorationItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.GetMomentBatchByVidReq = function () {
  this.tId = new HUYA.UserId()
  this.vVideoId = new Taf.Vector(new Taf.INT64())
  this.iFreeFlag = 0
  this.iCdnDispatch = 0
  this.iCheckStatus = 0
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING())
  this.iOutterDataCond = 0
}

HUYA.GetMomentBatchByVidReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId)
  this.vVideoId = is.readVector(1, false, this.vVideoId)
  this.iFreeFlag = is.readInt32(2, false, this.iFreeFlag)
  this.iCdnDispatch = is.readInt32(3, false, this.iCdnDispatch)
  this.iCheckStatus = is.readInt32(4, false, this.iCheckStatus)
  this.mpExtInfo = is.readMap(5, false, this.mpExtInfo)
  this.iOutterDataCond = is.readInt32(6, false, this.iOutterDataCond)
}

HUYA.GetMomentBatchByVidReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId)
  os.writeVector(1, this.vVideoId)
  os.writeInt32(2, this.iFreeFlag)
  os.writeInt32(3, this.iCdnDispatch)
  os.writeInt32(4, this.iCheckStatus)
  os.writeMap(5, this.mpExtInfo)
  os.writeInt32(6, this.iOutterDataCond)
}

HUYA.GetMomentBatchByVidReq.prototype._clone = function () {
  return new HUYA.GetMomentBatchByVidReq()
}
HUYA.GetMomentBatchByVidReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.GetMomentBatchByVidReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}

HUYA.UserId = function () {
  this.lUid = 0
  this.sGuid = ''
  this.sToken = ''
  this.sHuYaUA = ''
  this.sCookie = ''
  this.iTokenType = 0
  this.sDeviceInfo = ''
  this.sQIMEI = ''
}

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid)
  this.sGuid = is.readString(1, false, this.sGuid)
  this.sToken = is.readString(2, false, this.sToken)
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA)
  this.sCookie = is.readString(4, false, this.sCookie)
  this.iTokenType = is.readInt32(5, false, this.iTokenType)
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo)
  this.sQIMEI = is.readString(7, false, this.sQIMEI)
}

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid)
  os.writeString(1, this.sGuid)
  os.writeString(2, this.sToken)
  os.writeString(3, this.sHuYaUA)
  os.writeString(4, this.sCookie)
  os.writeInt32(5, this.iTokenType)
  os.writeString(6, this.sDeviceInfo)
  os.writeString(7, this.sQIMEI)
}

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId()
}
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value)
}
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
}
